import { Hourglass, Loader2, RefreshCcw, ShieldAlert } from "lucide-react";
import { PageHero } from "@/components/layout/PageHero";
import { useI18n } from "@/i18n/I18nContext";

const Waiting = ({ state, t }) => (
  <div className="metal-red fade-up relative overflow-hidden rounded-3xl p-6 sm:p-10" data-testid="queue-screen">
    <div className="flex flex-col gap-6 sm:flex-row sm:items-center">
      <div className="relative flex h-28 w-28 shrink-0 items-center justify-center">
        <span className="absolute inset-0 animate-ping rounded-full bg-[rgba(245,197,66,0.18)]" />
        <span className="relative flex h-28 w-28 items-center justify-center rounded-full border-2 border-[var(--gold)] bg-black/60 font-display text-4xl font-black gold-text" data-testid="queue-position-number">
          {state.position}
        </span>
      </div>
      <div className="min-w-0">
        <p className="font-display text-base font-bold text-white md:text-lg" data-testid="queue-position-text">
          {t("queue.position", { n: state.position })}
        </p>
        <p className="mt-3 text-sm text-red-100/85">{t("queue.info")}</p>
        <p className="mt-4 flex flex-wrap items-center gap-3 text-xs text-[var(--gold-bright)]">
          <span className="inline-flex items-center gap-1.5"><Hourglass className="h-4 w-4" /> {t("queue.waitingTotal", { n: state.waiting })}</span>
          <span className="inline-flex items-center gap-1.5 text-red-100/70"><span className="h-2 w-2 animate-pulse rounded-full bg-[var(--gold)]" /> {t("queue.live")}</span>
        </p>
      </div>
    </div>
  </div>
);

const Full = ({ t, onRetry }) => (
  <div className="card-carbon fade-up rounded-3xl p-6 sm:p-10" data-testid="queue-full-screen">
    <ShieldAlert className="h-10 w-10 text-[var(--red-bright)]" />
    <p className="mt-4 font-display text-base font-bold text-white md:text-lg" data-testid="queue-full-text">{t("queue.full")}</p>
    <button type="button" className="btn-gold mt-6" onClick={onRetry} data-testid="queue-retry-btn">
      <RefreshCcw className="h-4 w-4" /> {t("queue.retry")}
    </button>
  </div>
);

export const QueueScreen = ({ state, onRetry }) => {
  const { t } = useI18n();
  const busy = state.status === "joining" || state.status === "error";
  return (
    <div data-testid="queue-page">
      <PageHero eyebrow={t("queue.eyebrow")} title={busy ? null : t("queue.title")} />
      <section className="mx-auto max-w-3xl px-4 sm:px-8">
        {busy && (
          <p className="flex items-center gap-3 text-neutral-300" data-testid="queue-connecting">
            <Loader2 className="h-5 w-5 animate-spin text-[var(--gold)]" /> {t("queue.connecting")}
          </p>
        )}
        {state.status === "waiting" && <Waiting state={state} t={t} />}
        {state.status === "full" && <Full t={t} onRetry={onRetry} />}
      </section>
    </div>
  );
};
